import { render, staticRenderFns } from "./RollingText.vue?vue&type=template&id=06469534&scoped=true"
import script from "./RollingText.vue?vue&type=script&lang=js"
export * from "./RollingText.vue?vue&type=script&lang=js"
import style0 from "./RollingText.vue?vue&type=style&index=0&id=06469534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06469534",
  null
  
)

export default component.exports